import s from './Account.module.css';
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {Link, Navigate, NavLink} from "react-router-dom";
import React, {useState} from "react";
import {getAuth, signInWithEmailAndPassword} from "firebase/auth";
import {useDispatch, useSelector} from "react-redux";
import {loginUser} from "../../store/AuthSlice";
import {readUserData} from "../../firebase";
import {setUserData} from "../../store/UserInfoSlice";


const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [formError, setFormError] = useState(null);
    const dispatch = useDispatch();
    const isAuth = useSelector(state => state.authUser.isAuth);


    const handleSubmit = async (e, email, password) => {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, email, password)
            .then(({user}) => {
                dispatch(loginUser({
                    email: user.email,
                    userId: user.uid
                }));
                readUserData(user.uid).then((userInfo) => {
                    dispatch(setUserData({
                        name: userInfo.name,
                        surname: userInfo.surname,
                        phone: userInfo.phone,
                        country: userInfo.country,
                        region: userInfo.region,
                        city: userInfo.city,
                        address: userInfo.address,
                    }))
                });
            })
            .catch((error) => {
                setFormError(error.message);
            });

        e.preventDefault();
    }

    return (
        <div className={s.loginItems}>
            <div className={s.loginToRegistration}>
                {isAuth ? <Navigate to="/account"/> : null}
                <h4>НОВЫЙ КЛИЕНТ</h4>
                <h5>Регистрация</h5>
                <p>Создание учетной записи поможет покупать быстрее. Вы сможете контролировать состояние заказа, а также
                    просматривать заказы сделанные ранее. Вы сможете накапливать призовые баллы и получать скидочные
                    купоны.
                    А постоянным покупателям мы предлагаем гибкую систему скидок и персональное обслуживание.</p>
                <BuyButton><NavLink to="/account/registration">ПРОДОЛЖИТЬ</NavLink></BuyButton>
            </div>
            <div className={s.loginSection}>
                <h5>Войти в Личный Кабинет</h5>
                <form onSubmit={(e) => handleSubmit(e, email, password)}>
                    <div>
                        <h5>E-Mail:</h5>
                        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"
                               placeholder="example@gmail.com"/>
                    </div>
                    <div>
                        <h5>Пароль:</h5>
                        <input autoComplete="off" value={password} onChange={(e) => setPassword(e.target.value)}
                               type="password" placeholder="qwerty132"/>
                    </div>
                    <Link to="">Забыли пароль?</Link>
                    {formError ? <p>Ошибка: {formError}</p> : null}
                    <BuyButton>ПРОДОЛЖИТЬ</BuyButton>
                </form>
            </div>
        </div>
    )
}

export default Login;